import React from 'react'

import CompanyAvatar from '@/components/misc/CompanyAvatar'
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import useAppSelector from '@/hooks/useAppSelector'
import { useAuth } from '@/hooks/useAuth'
import { useUserCompanies } from '@/hooks/useUserCompanies'
import { isDevelopment } from '@/lib/helpers/envHelpers'
import { truncateText } from '@/lib/helpers/helperFunctions'
import { cn } from '@/lib/utils'
import { selectCompanyTypes } from '@/redux/slices/commonData'
import { selectCurrentCompany } from '@/redux/slices/session'
import { CompanyCollectionItem } from '@/types/responses/companies'

const UserCompanies: React.FC = () => {
  const currentCompany = useAppSelector(selectCurrentCompany)
  const userCompanies = useUserCompanies()
  const { updateCompanyContext } = useAuth()
  const companyTypes = useAppSelector(selectCompanyTypes)
  const MAX_COMPANY_NAME_LENGTH = 45

  const companySections = companyTypes.map((companyType) => ({
    companyTypeLabel: companyType.shortName,
    companies: userCompanies.filter(
      (userCompany) => userCompany.companyType['@id'] === companyType['@id'],
    ),
  }))

  if (!userCompanies.length) {
    return null
  }

  return (
    <>
      {companySections.map(({ companyTypeLabel, companies }) =>
        renderCompanies(companyTypeLabel, companies),
      )}
    </>
  )

  function renderCompanies(
    companyTypeLabel: string,
    companies: CompanyCollectionItem[],
  ) {
    if (companies.length === 0) {
      return null
    }

    return (
      <React.Fragment key={companyTypeLabel}>
        <DropdownMenuLabel>{companyTypeLabel}</DropdownMenuLabel>

        {companies.map((company) => (
          <DropdownMenuItem
            className={cn('text-[13px]', {
              'bg-accent': company.id === currentCompany?.id,
            })}
            onClick={() => updateCompanyContext({ company: company['@id'] })}
            key={company.id + company.companyType.code}
            title={
              isDevelopment()
                ? `ID: ${company.id.toString()} - ${company.presentationName}`
                : company.presentationName.length > MAX_COMPANY_NAME_LENGTH
                  ? company.presentationName
                  : undefined
            }
          >
            <CompanyAvatar company={company} size="sm" />
            {/*<CompanyTypeIcon
              companyTypeCode={company.companyType.code}
              style={{ width: '16px', height: '16px' }}
            />*/}

            {truncateText(company.presentationName, {
              maxLength: MAX_COMPANY_NAME_LENGTH,
            })}
          </DropdownMenuItem>
        ))}

        <DropdownMenuSeparator />
      </React.Fragment>
    )
  }
}

export default UserCompanies
